import React from 'react';
import { colors } from '../constants';

const CheckMarkCircle = ({ color, width, height, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
  >
    <path
      fill={color}
      d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,1.77635684e-15 10,1.77635684e-15 C15.5228475,1.77635684e-15 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10,18.8571429 C14.8916649,18.8571429 18.8571429,14.8916649 18.8571429,10 C18.8571429,5.10833507 14.8916649,1.14285714 10,1.14285714 C5.10833507,1.14285714 1.14285714,5.10833507 1.14285714,10 C1.14285714,14.8916649 5.10833507,18.8571429 10,18.8571429 Z M6.339884,10.45153 L7.92934143,12.0409874 L13.4652287,6.87415932 C13.6959434,6.65882563 14.057537,6.67129437 14.2728707,6.90200905 C14.4882044,7.13272372 14.4757356,7.49431736 14.245021,7.70965106 L8.30554459,13.2531623 C8.08043334,13.4632662 7.7293243,13.4572144 7.51158743,13.2394775 L5.53176197,11.259652 C5.30860523,11.0364953 5.30860523,10.6746867 5.53176197,10.45153 C5.75491871,10.2283733 6.11672727,10.2283733 6.339884,10.45153 Z"
    />
  </svg>
);

CheckMarkCircle.defaultProps = {
  color: colors.darkGreenhouseGreen,
  width: 20,
  height: 20,
};

export default CheckMarkCircle;
